import { getUrl } from '../assets/js/Axios.js';

let Api = {
  Index:{
    // 获取拼多多授权
    getCodeUrl:(options) => {
      return getUrl('/v1/PDDGoodsAPI/getCodeUrl','get',options)
    },
  },
  User:{
    // 登录
    Login:(options) => {
      return getUrl('/user/login','post',options)
    },
    // 注册
    UserReg:(options) => {
      return getUrl('/user/reg','post',options)
    },
    // 修改账号信息
    UserSet:(options) => {
      return getUrl('/user/set','post',options)
    },
    // 退出
    logout:(options) => {
      return getUrl('/user/logout','post',options)
    },
    // 获取前端sdk_code
    getJsSdkCode:(options) => {
      return getUrl('/PDDGoodsApi/getJsSdkCode','get',options)
    },
    // 获取拼多多授权地址
    getCodeUrl:(options) => {
      return getUrl('/PDDGoodsAPI/getCodeUrl','get',options)
    },
    // 拼多多登录
    pddLogin:(options) => {
      return getUrl('/PDDGoodsApi/pddLogin','post',options)
    },
    // 接收拼多多code
    PDDRedirect:(options) => {
      return getUrl('/PDDGoodsApi/PDDRedirect','get',options)
    },
  },
  Goods:{
    // 获取商品列表
    getShopList:(options) => {
      return getUrl('/goods/goodslist','get',options)
    },
    // 删除绑定
    delShop:(options) => {
      return getUrl('/user/delShop','post',options)
    },
    // // 更改授权
    // codeBangUser:(options) => {
    //   return getUrl('/user/codeBangUser','post',options)
    // },
    // 同步商品
    getPddGoods:(options) => {
      return getUrl('/goods/getPddGoods','post',options)
    },
    // 复制淘宝商品
    goodsCopy:(options) => {
      return getUrl('/goodsCopy/tb','get',options)
    },
    // 获取sku表
    getSkuInfo:(options) => {
      return getUrl('/goods/getSkuInfo','get',options)
    },
    // 修改SKU库存
    setSkuQuantity:(options) => {
      return getUrl('/goods/setSkuQuantity','post',options)
    },
    // 获取上传记录
    getCopyGoodsList:(options) => {
      return getUrl('/goodscopy/getCopyGoodsList','get',options)
    },
    // 获取商品详情
    getGoodsInfo:(options) => {
      return getUrl('/goods/getGoodsInfo','get',options)
    },

  },
  Shop:{
    // 拼多多code添加店铺
    addShop:(options) => {
      return getUrl('/user/addShop','post',options)
    },
    // 更改授权
    codeBangUser:(options) => {
      return getUrl('/user/codeBangUser','post',options)
    },
    // 获取店铺列表
    getShopList:(options) => {
      return getUrl('/user/getShopList','get',options)
    },
    // 商品详情
    getGoodsInfo:(options) => {
      return getUrl('/goods/getGoodsInfo','get',options)
    },
    // 复制淘宝商品->获取用户物流模板
    getPddShopList:(options) => {
      return getUrl('/PDDGoodsApi/getPddShopList','get',options)
    },

    // 复制淘宝商品->获取类目属性
    getPddCateAttr:(options) => {
      return getUrl('/PDDGoodsApi/getPddCateAttr','get',options)
    },
    // 复制淘宝商品->上传图片到拼多多
    uploadImg:(options) => {
      return getUrl('/PDDGoodsApi/uploadImg','post',options)
    },
    // 复制淘宝商品->编辑数据上传到平多多
    saveToPdd:(options) => {
      return getUrl('/PDDGoodsApi/saveToPdd','post',options)
    },
    // 复制淘宝商品->查看上传状态
    getUptatus:(options) => {
      return getUrl('/PDDGoodsApi/getUptatus','get',options)
    },

  },
  PddUpl:{
    // 获取店铺列表
    getShopList:(options) => {
      return getUrl('/user/getShopList','get',options)
    },
    // 获取店铺列表2
    getPddShopList:(options) => {
      return getUrl('/pddShop/getPddShopList','get',options)
    },
    // 获取复制的商品信息
    getDsyGoodsInfo:(options) => {
      return getUrl('/goodsCopy/getDsyGoodsInfo','get',options)
    },
    // 获取快递模板列表
    getPddLogisticsTemplate:(options) => {
      return getUrl('/pddGoodsApiV2/getPddLogisticsTemplate','get',options)
    },
    // 查找品牌
    searchBrandList:(options) => {
      return getUrl('/pddGoodsApiV2/searchBrandList','get',options)
    },
    // 拼多多类目
    getPddCat:(options) => {
      return getUrl('/pddGoodsApiV2/getPddCat','get',options)
    },
    // 类目规则
    getCatRule:(options) => {
      return getUrl('/pddGoodsApiV2/getCatRule','get',options)
    },
    // 获取销售属性
    getPddGoodsSpec:(options) => {
      return getUrl('/pddGoodsApiV2/getPddGoodsSpec','get',options)
    },
    // 获取属性值ID
    getSpecValueId:(options) => {
      return getUrl('/pddGoodsApiV2/getSpecValueId','get',options)
    },
    // 上传图片到拼多多
    PddUplImg:(options) => {
      return getUrl('/pddImg/upPddImg','post',options)
    },
    // 上传临时图片
    saveTmpImg:(options) => {
      return getUrl('/pddImg/saveTmpImg','post',options)
    },
    // 上传商品
    saveToPdd:(options) => {
      return getUrl('/pddGoodsApiV2/saveToPdd','post',options)
    },

    // 获取利润库存
    getInfo:(options) => {
      return getUrl('/user/getInfo','get',options)
    },
    // 设置库存利润
    setInfo:(options) => {
      return getUrl('/user/setInfo','post',options)
    },
  },
  upllist:{
    // 上传记录
    upList:(options) => {
      return getUrl('/pddGoodsApiV2/upList','get',options)
    },
  },
}
export default{
  Api
}



// WEBPACK FOOTER //
// ./src/Api/Api.js